module.exports = __webpack_public_path__ + "img/footLogo.20779e99.png";